export default __webpack_public_path__ + "static/media/GettyImages-463029317-581033455f9b58564c9918cd.8cceed32.webp";